<template>
    <div>
        <Header page-type="manage" class="no_print">
            <template v-slot:menu_left><div class="icn_green"><p role="button" @click.prevent.stop="operationCheck('cancel')">＜戻る</p></div>
            </template>
            <template v-slot:menu_center>
                <div class="menu_calendar_unit">
                    <p class="menu_calendar_prev" role="button" @click.prevent.stop="operationCheck('befoer')"><i class="fas fa-chevron-left"></i>前日</p>
                    <p class="menu_calendar_date">{{year}}年{{month}}月{{day}}日</p>
                    <p class="menu_calendar_next" role="button" @click.prevent.stop="operationCheck('next')">翌日<i class="fas fa-chevron-right"></i></p>
                </div>
            </template>
            <template v-slot:menu_right>
                <div class="btn_check letter_spa">
                    <a role="button" @click.stop.prevent="onClick">確認</a>
                </div>
            </template>
        </Header>
        <Report @page-changed="onPageChanged" @submitted="onSubmitted" :date="date()" :confirmed="confirmed" :commentReFlg="commentFlg"></Report>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">コメント登録確認</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>入力したコメントはまだ登録されていません。画面遷移すると入力したコメント破棄されます。画面遷移してよろしいですか？</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeCheckModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="actionCall">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from '@/app/components/Header.vue'
    import Report from '@/app/components/Report.vue'
    export default {
        name: 'ReportDetail',
        components: {
            Header,
            Report,
        },
        props: {
            year: {
                type: Number,
                required: true,
            },
            month: {
                type: Number,
                required: true,
            },
            day: {
                type: Number,
                required: true,
            }
        },
        data () {
            return {
                showContent: false,
                commentFlg: false,
                isLastPage: false,
                confirmed: false,
            }
        },
        computed: {
            prevDate: function () {
                let day = this.date()
                day.setDate(day.getDate()-1)
                return day
            },
            nextDate: function () {
                let day = this.date()
                day.setDate(day.getDate()+1)
                return day
            }
        },
        methods: {
            date: function () {
                return new Date(this.year, this.month-1, this.day)
            },
            onClick: function () {
                this.confirmed = true
            },
            onSubmitted: function (result) {
                this.confirmed = false
                if (!result) {
                    return
                }
                this.$store.dispatch('dialog/setDialog', {
                    title: '報告書確認',
                    text: '報告書の確認が完了しました。',
                    button: {
                        cancel: { show: false, text: null },
                        done: { show: true, text: 'OK' }
                    },
                    next: null,
                    show: true,
                })

                // コメント差分フラグを初期化
                this.commentFlg = false;
            },
            onPageChanged: function (index) {
                if (index === 2) {
                    this.isLastPage = true
                } else {
                    this.isLastPage = false
                }
            },
            onBefoer() {
                // 前日
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'report',
                        params: {year: this.prevDate.getFullYear(), month: this.prevDate.getMonth()+1, day: this.prevDate.getDate()}
                    })
            },
            onNext() {
                // 翌日
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'report',
                        params:{year:this.nextDate.getFullYear(), month: this.nextDate.getMonth()+1, day: this.nextDate.getDate()}
                    })
            },
            onCancel() {
                // 戻る
                this.actionStatus = "";
                this.$router.push(
                    {
                        name: 'calendar',
                        params: {year: this.year, month:this.month}
                    })
            },
            operationCheck(action){
                this.actionStatus = action;
                if(this.commentFlg){
                    this.showContent = true;
                    return null;
                }
                // 差分がない場合
                this.actionCall();
            },
            actionCall(){
                // 判定フラグを初期化
                this.commentFlg = false;
                this.showContent = false;
                switch (this.actionStatus) {
                    case "befoer":
                        this.onBefoer();
                        break;
                    case "next":
                        this.onNext();
                        break;
                    case "cancel":
                        this.onCancel();
                        break;
                }
            },
            closeCheckModel(){
                this.showContent = false;
            },
        },
    }
</script>
